import { activityInfo, pageInfo } from '@/types';
import {
  ActivityListParams,
  ListResult,
  getActivityList,
  getFeaturedActivityList,
  getEndedActivityList,
  getDailyActivityList,
} from '@/services';

import { create } from 'zustand';
import { Banner, getCmsBanners } from '@/services/cms';
// import { chaninId } from '@/utils/constant';

interface StoreType {
  bannerData: Banner | null;
  bannerDataIsReady: boolean;
  activityList?: activityInfo[];
  featuredActivityList?: activityInfo[];
  featuredActivityListIsReady?: boolean;
  endedActivityList?: activityInfo[];
  endedActivityListIsReady?: boolean;
  dailyActivityList?: activityInfo[];
  activityPageInfo: pageInfo | null;
  dailyAactivityPageInfo: pageInfo | null;
  fetchBannerList: () => Promise<void>;
  fetchFeaturedActivityList: () => Promise<
    ListResult<activityInfo> | undefined
  >;
  fetchEndedActivityList: () => Promise<void>;
  fetchDailyActivityList: () => Promise<void>;
  fetchActivityList: (data?: ActivityListParams) => Promise<void>;
  // init: () => Promise<void>;
}

export const useHomeStore = create<StoreType>()(
  (
    set
    // get
  ) => ({
    bannerData: null,
    bannerDataIsReady: false,
    activityList: [],
    featuredActivityList: [],
    featuredActivityListIsReady: false,
    endedActivityListIsReady: false,
    endedActivityList: [],
    activityPageInfo: null,
    dailyActivityList: [],
    dailyAactivityPageInfo: null,
    fetchBannerList: async () => {
      try {
        const { result } = await getCmsBanners();
        if (result) {
          set(
            () =>
              ({
                bannerData: result[0] || {},
              }) as any
          );
        }
      } catch (e) {
        console.error(e);
      }
      set(
        () =>
          ({
            bannerDataIsReady: true,
          }) as any
      );
    },
    // 精选活动列表
    fetchFeaturedActivityList: async () => {
      try {
        const { result } = await getFeaturedActivityList({
          pageNo: 1,
          pageSize: 100,
        });
        if (result) {
          set(
            () =>
              ({
                featuredActivityList: result.dataList || [],
                featuredActivityListIsReady: true,
                activityPageInfo: result.pageInfo || {},
              }) as any
          );
        }
        return result;
      } catch (e) {
        console.error(e);
        // set(() => ({
        //   featuredActivityList: [],
        //   activityPageInfo: {},
        // }));
      }
    },
    // 已结束热门活动列表
    fetchEndedActivityList: async () => {
      try {
        const { result } = await getEndedActivityList({
          pageNo: 1,
          pageSize: 100,
        });
        // result.dataList = []
        if (result) {
          set(
            () =>
              ({
                endedActivityList: result?.dataList || [],
                endedActivityListIsReady: true,
                activityPageInfo: result.pageInfo || {},
              }) as any
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 日常活动列表
    fetchDailyActivityList: async () => {
      try {
        const { result } = await getDailyActivityList({
          pageNo: 1,
          pageSize: 1000,
        });
        if (result) {
          set(
            () =>
              ({
                dailyActivityList: result?.dataList,
                // result?.dataList.filter((item) => item.rewardInfos.length > 0) ||
                // [],
                dailyAactivityPageInfo: result.pageInfo || {},
              }) as any
          );
        }
        // console.log('getActivityList:', result);
      } catch (e) {
        console.error(e);
      }
    },
    fetchActivityList: async (data?: ActivityListParams) => {
      // console.log(data);

      try {
        const { result } = await getActivityList(data);
        if (result) {
          set(
            () =>
              ({
                activityList: result?.dataList || [],
                activityPageInfo: result.pageInfo || {},
              }) as any
          );
        }
        // console.log('getActivityList:', result);
      } catch (e) {
        console.error(e);
      }
    },
    // init: async () => {
    //   const state = get();
    //   state.fetchActivityList({ limit: 10, start: 0, chainId: chaninId });
    //   // state.fetchMarketInfo();
    // },
  })
);

// export default useStore;
